import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContractWidget } from '../../../../models';
import { Contract } from '../../../../models/contract';
import { PoolObject } from '../../../../core/contract/poolObject.model';
import { PortalCollapsibleComponent } from '../../../../customer-portal/components/portal-collapsible/portal-collapsible.component';
import { SharedModule } from '../../../../shared/shared.module';
import { PortalWidgetDetailsComponent } from '../../../../customer-portal/components/portal-widget-details/portal-widget-details.component';

@Component({
    selector: 'app-musikinstrumente-schulen-widget',
    imports: [PortalCollapsibleComponent, SharedModule, PortalWidgetDetailsComponent],
    templateUrl: './musikinstrumente-schulen-klasse-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MusikinstrumenteSchulenWidgetKlasseComponent implements ContractWidget {
    @Input({ required: true })
    public contract: Contract;

    protected get klasse(): PoolObject[] {
        return this.contract.objectPool;
    }
}
